<template>
  <template v-if="hasVesselDepartureArrival">
    <p v-if="vessel.portOfLoading?.departure?.carriage?.vehicleName">
      <span>{{ vessel.portOfLoading.departure.carriage.vehicleName }}</span>
      <span
        v-if="
          vessel.portOfDischarge?.arrival?.carriage?.vehicleName !==
          vessel.portOfLoading?.departure?.carriage?.vehicleName
        "
        class="color-neutral-subtle"
      >
        &nbsp;({{ $t("vessel.first") }})</span
      >
    </p>
    <span v-else>-</span>
    <p
      v-if="
        vessel.portOfDischarge?.arrival?.carriage?.vehicleName !==
        vessel.portOfLoading?.departure?.carriage?.vehicleName
      "
    >
      <span>{{ vessel.portOfDischarge?.arrival?.carriage?.vehicleName }}</span
      ><span class="color-neutral-subtle">&nbsp;({{ $t("vessel.last") }})</span>
    </p>
  </template>
  <p v-else class="color-neutral-subtle not-available">
    {{ $t("common.notAvailable") }}
  </p>
</template>

<script>
export default {
  props: {
    vessel: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasVesselDepartureArrival() {
      return Boolean(
        this.vessel.portOfLoading?.departure?.carriage?.vehicleName ||
          this.vessel.portOfDischarge?.arrival?.carriage?.vehicleName
      );
    }
  }
};
</script>
